import React from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export interface MuiCheckboxProps extends Omit<CheckboxProps, 'color'> {
  label: string;
}

/**
 * MUI-first checkbox + label pairing — no Tailwind-only sibling exists
 * yet (LoginPage previously used a native <input type="checkbox">).
 */
export const MuiCheckbox: React.FC<MuiCheckboxProps> = ({ label, id, ...rest }) => (
  <FormControlLabel
    control={<Checkbox id={id} color="primary" size="small" {...rest} />}
    label={label}
    sx={{
      ml: -0.5,
      '& .MuiFormControlLabel-label': {
        fontSize: '0.875rem',
        color: 'text.secondary',
      },
    }}
  />
);

export default MuiCheckbox;
